import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../assets/css/PrivacyPolicy.css";

// Section imports
import Section1Introduction from "../components/privacySections/Section1Introduction";
import Section2DataController from "../components/privacySections/Section2DataController";
import Section3InformationCollection from "../components/privacySections/Section3InformationCollection";
import Section4CollectionMethod from "../components/privacySections/Section4CollectionMethod";
import Section5Purpose from "../components/privacySections/Section5Purpose";
import Section6Legal from "../components/privacySections/Section6Legal";
import Section7Sharing from "../components/privacySections/Section7Sharing";
import Section8DataTransfer from "../components/privacySections/Section8DataTransfer";
import Section9Retention from "../components/privacySections/Section9Retention";
import Section10Security from "../components/privacySections/Section10Security";
import Section11DataProtection from "../components/privacySections/Section11DataProtection";
import Section12Cookies from "../components/privacySections/Section12Cookies";
import Section13Children from "../components/privacySections/Section13Children";
import Section14Updates from "../components/privacySections/Section14Updates";

const PrivacyPolicy = () => {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Comparedly</title>
        <meta name="description" content="Your privacy is important to us. Read Comparedly's Privacy Policy to understand how we collect, use, and protect your data." />
        <meta property="og:title" content="Privacy Policy | Comparedly" />
        <meta property="og:description" content="Your privacy is important to us. Read Comparedly's Privacy Policy to understand how we collect, use, and protect your data." />
      </Helmet>
      <Navbar />
      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <p>Last updated: April 7, 2025</p>

        <Section1Introduction />
        <Section2DataController />
        <Section3InformationCollection />
        <Section4CollectionMethod />
        <Section5Purpose />
        <Section6Legal />
        <Section7Sharing />
        <Section8DataTransfer />
        <Section9Retention />
        <Section10Security />
        <Section11DataProtection />
        <Section12Cookies />
        <Section13Children />
        <Section14Updates />
        {/* Add more sections as needed */}
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
